import "./Breadcrum.css";
import arrow_icon from "../Assets/breadcrum_arrow.png";
import { Link } from "react-router-dom";

const Breadcrum = ({ product }) => {
    // Generate the breadcrumb paths
    const breadcrumbs = [
        { name: "Home", path: "/" },
        { name: "Shop", path: "/" },
        { name: product.category, path: `/${product.category.toLowerCase().replace(/\s+/g, '-')}` },
        { name: product.name, path: null } // Current page (not clickable)
    ];

    return (
        <div className="breadcrumb">
            {breadcrumbs.map((item, index) => (
                <div key={index} className="breadcrumb-item-container">
                    {item.path ? (
                        <Link to={item.path} className="breadcrumb-link">
                            {item.name}
                        </Link>
                    ) : (
                        <span className="breadcrumb-current">{item.name}</span>
                    )}
                    {index < breadcrumbs.length - 1 && (
                        <img src={arrow_icon} alt=">" className="breadcrumb-arrow" />
                    )}
                </div>
            ))}
        </div>
    );
};

export default Breadcrum;